import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import NameInput from "~/components/traffic/lookup/Forms/Inputs/NameInput"

import withTranslations from "~/components/_hocs/withTranslations"

import InputTitle from "./InputTitle"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  firstName: all.store.trafficLookup.firstName,
  middleName: all.store.trafficLookup.middleName,
  lastName: all.store.trafficLookup.lastName,
  changeName: all.store.trafficLookup.changeName,
  changeKey: all.store.trafficLookup.changeKey,
}))
@observer
class Name extends Component {
  handleChange = (e) => {
    this.props.changeName(e.target.name, e.target.value)

    const firstNameString =
      e.target.name === "firstName"
        ? e.target.value
        : `${this.props.firstName} `
    const middleNameString =
      e.target.name === "middleName"
        ? e.target.value
        : `${this.props.middleName} `
    const lastNameString =
      e.target.name === "lastName" ? e.target.value : `${this.props.lastName}`

    const fullNameString = firstNameString + middleNameString + lastNameString
    this.props.changeKey("fullName", fullNameString)
  }

  render() {
    const firstNameErrorHandler = this.props.validateDisplayMessage("firstName")
    const lastNameErrorHandler = this.props.validateDisplayMessage("lastName")
    const nameErrorHandler = firstNameErrorHandler || lastNameErrorHandler
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate("label")}
          <Spacer direction="width" mobile={11} desktop={11} />
        </InputTitle>
        <Spacer desktop={16} mobile={4} />
        <NameInput
          firstName={this.props.firstName}
          middleName={this.props.middleName}
          lastName={this.props.lastName}
          handleChange={this.handleChange}
          error={nameErrorHandler}
        />
        <FormError error={nameErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(Name, "form.general.fullName")
